import { IsMobile } from 'app/app';
import { setPayementError } from 'app/modules/corporate/service/corporate.service';
import { initializeCallback } from 'app/modules/journey/service/step.service';
import { AlertDanger } from 'app/shared/components/alert';
import FormModal from 'app/shared/components/pop-up/form-modal';
import { IRootState } from 'app/shared/reducers';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Button } from 'reactstrap';
import { loading, RD, SRD, success } from 'srd';

export const Callback = () => {
  const isMobile = useContext(IsMobile);
  const { subscriptionNumber, callback, status, authorization } = useParams<{ subscriptionNumber: string, callback: string, status: string, authorization: string }>();
  // callback = confirmation, cancellation, failure

  const dispatch = useDispatch();
  const history = useHistory();

  const appStyleCreatedStore = useSelector((state: IRootState) => state.cms.appStyleCreated);
  const stepsConfigStore = useSelector((state: IRootState) => state.config.steps);

  const [onCallbackSRD, setCallbackSRD] = React.useState<RD<string, string>>(loading())
  const [formModal, setFormModal] = React.useState(false);
  const [messageModal, setMessageModal] = React.useState("");

  const closeForm = () => {
    setFormModal(false);
    history.replace('/' + subscriptionNumber);
  }

  useEffect(() => {
    if (appStyleCreatedStore && stepsConfigStore) {
      if (callback === "failure") {
        setCallbackSRD(success(""));
        setMessageModal("Merci de reprendre votre parcours de souscription. Les données déjà enregistrées seront reprises car l’adhésion en attente est déjà existante.") // TODO: translate
        setFormModal(!formModal)
      } else if (callback === "payment" || callback === "confirmation" || callback === "cancellation") {
        dispatch(initializeCallback(callback + 'Step', subscriptionNumber));
      } else if (callback === "paymentDone") {
        dispatch(initializeCallback('paymentConfirmationStep', subscriptionNumber));
      } else if (callback === "paymentFailure") {
        dispatch(setPayementError(status, authorization))
        dispatch(initializeCallback('paymentFailureStep', subscriptionNumber));
      }
    }
  }, [callback, appStyleCreatedStore, stepsConfigStore])


  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => <div className="app-loading"><div className="lds-dual-ring" style={{ backgroundColor: 'white', opacity: 0.8, borderRadius: 6 }}></div></div>,
    failure: (e) => <AlertDanger><span>{"Une erreur s'est produite"}</span>{e && <span><br />{e}</span>}</AlertDanger>,
    success: (d) => <div>
      <FormModal modal={formModal} setModal={setFormModal} className={isMobile ? 'modalCls' : 'desktopModalCls'}>
        <div className="amountModalDescription">
          {messageModal}
        </div>
        <Button className="devicesListModalBtn" onClick={() => closeForm()}>Compris</Button>
      </FormModal>
    </div>
  }, onCallbackSRD)

  return view
}
